import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EnumState = {
  [key: string]: {
    value: string;
    label: string;
  }[];
};

export type ClientFeatureFlags = {
  revision: string;
  flags: Record<string, boolean>;
};

export type EnumsState = EnumState & {
  featureFlags?: ClientFeatureFlags;
};

const initialState: EnumsState = {};

export const enumsSlice = createSlice({
  name: 'enums',
  initialState,
  reducers: {
    setEnums: (state, { payload }: PayloadAction<EnumsState>) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setEnums } = enumsSlice.actions;

export const enumsReducer = enumsSlice.reducer;
